import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ProjectDto } from 'projects/shared/src/lib/models/Project';
import { ProjectGroupRoleUser, RoleDto } from 'projects/shared/src/lib/models/SquirrelRoles';
import { UserDto, UsersDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectRolesService } from 'projects/shared/src/lib/services/project-roles.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { debounceTime, finalize, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'add-user-group-role-dialog',
  templateUrl: './add-user-group-role-dialog.component.html',
  styleUrls: ['./add-user-group-role-dialog.component.scss']
})
export class AddUserGroupRoleDialogComponent implements OnInit {

  userGroupRoleForm!: FormGroup;
  isLoading = false;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10000;

  usersDto!: UsersDto;
  userDtos: UserDto[] = [];
  userDto!: UserDto;

  //tenantUsers!: UserDto[]

  groupRoleDto!: RoleDto;
  projectGroupRoleUser: ProjectGroupRoleUser = new ProjectGroupRoleUser();


  userId!: string;

  
  confirmationMessage: string;
  projectDto!: ProjectDto;
  
  _db!:string;

  _targetIsTenantDB: boolean = true;
  _userSelected = false;
  
  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public _dialogRef: MatDialogRef<AddUserGroupRoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService,
    private projectRoleService: ProjectRolesService,
    private tenantService:TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private oauthService: OAuthServiceService,
  ) {
    this.confirmationMessage = data.message;
  }

  ngOnInit() {

    this._targetIsTenantDB = this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation;
    
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
              this._db = dbrole;
            }
          });
        }
      }
    });

    this.createUserGroupRoleForm();
    this.retrieveUsers();   
  }

  retrieveUsers() {    
    let searchText: string = this.userGroupRoleForm.get('userName')?.value;
    searchText = ' ';

    if(!this._targetIsTenantDB) {      
      //      if(this._db) {      
              this.searchMaindb(searchText);      
          }
    else{
      this.searchTenantdb(searchText);
    }
  }
  
  searchMaindb(searchText: string) {
    console.log("---------> add-user-group-role: search in main db")
    this.accountService.getAllUsers(searchText, this.currentPage, this.pageSize).subscribe({
      next: (userDtos: UserDto[]) => {
        this.userDtos = userDtos;
        if(this.userDtos.length > 0){
          //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDUSERS"]} `);
        }
        else{
          this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NORETRIEVEDUSERS"]} `);
        }        
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEUSERSERROR"]}`)
    });

    this.userGroupRoleForm.get('userName')?.valueChanges
      .pipe(debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap((value: any) => this.accountService.getAllUsers(value, this.currentPage, this.pageSize)
          .pipe(finalize(() => this.isLoading = false))))
      .subscribe({
        next: (userDtos: UserDto[]) => {
          this.userDtos = userDtos;
          this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERFOUND"]} `);
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERFOUNDERROR"]}`)
      });
  }

  searchTenantdb(searchText: string) {
    console.log("---------> add-user-group-role: search in tenant db")
    let db:string = this.tenantService.currentTenantName;
    this.tenantService.loadTenantUsers(db, searchText, this.currentPage, this.pageSize).subscribe({
      next: (userDto: UserDto[]) => {
        this.userDtos = userDto.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));
//        this.rowData = this.userData.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));

        if(this.userDtos.length > 0){
          //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDUSERS"]} `);
        }
        else{
          this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NORETRIEVEDUSERS"]} `);
        }        
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEUSERSERROR"]}`)
    });

    this.userGroupRoleForm.get('userName')?.valueChanges
      .pipe(debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap((value: any) => this.tenantService.loadTenantUsers(db, value, this.currentPage, this.pageSize)
          .pipe(finalize(() => this.isLoading = false))))
      .subscribe({
        next: (userDto: UserDto[]) => {
          this.userDtos = userDto;
          //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERFOUND"]} `);
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERFOUNDERROR"]}`)
      });
  }

  createUserGroupRoleForm() {
    this.userGroupRoleForm = this.formBuilder.group({
      userName: [null, Validators.required],
      roleId: [this.data.id],
      name: [this.data.name]
    })
  }

  cancel() {
    this._dialogRef.close();
  }

  displayFn(user: any) {
    console.log("displayFn: user = ", user)
    if (user) { return user.userName; }
  }

  optionSelected(event: any) {
    console.log("event:", event)
    this.projectGroupRoleUser.roleId = this.data.roleId;
    this.projectGroupRoleUser.userId = event.option.value.id;
    this.projectGroupRoleUser.projectId = this.data.projectId;
    this.projectGroupRoleUser.roleName = this.data.roleName;
    this.projectGroupRoleUser.userName = (event.option.value.userName != "")?event.option.value.userName:event.option.value.email;
    this.projectGroupRoleUser.tenantId = event.option.tenantId;
    this._userSelected = true;
  }

  add() {
    // console.log("-----------> add-user-group-role-dialog add(): selected User = ", this.projectGroupRoleUser)
    if (this._userSelected) {
      this.insertInTenantdb(this.projectGroupRoleUser);
      this._dialogRef.close();
    } else
        this.notificationService.warning(`${this.translate.data["WARN"]}`, "Kein Benutzer aus der Liste ausgewählt!");
  }

  insertInTenantdb(projectGroupRoleUser: ProjectGroupRoleUser) {
    let db:string = this.tenantService.currentTenantName;
    this.tenantService.createProjectGroupRoleUser(projectGroupRoleUser, db).subscribe({
      next:(projectGroupRoleUser) => {
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTGROUPROLEUSERCREATED"]} `);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RPROJECTGROUPROLEUSERCREATEDERROR"]}`)
    });
  }

}
